module.exports = __webpack_public_path__ + "img/ufa-bet-support.be9566bd.png";